// AuthLayout — para pantallas pre-login (LoginPage tiene su layout custom
// editorial; las demás auth screens — ChooseTenant — usan este).
//
// Centrado, surface-base, wordmark arriba, content centrado vertical.

import type { ReactNode } from 'react';

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-surface-base px-6 py-10">
      <header className="text-center">
        <h1 className="font-serif text-3xl tracking-tight text-fg">
          Jidokap<span className="text-dot">.</span>
        </h1>
        <p className="mt-1.5 text-xs text-fg-secondary">Plataforma de gestión de producción</p>
      </header>
      <div className="w-full max-w-md">{children}</div>
    </main>
  );
}
